/**
 * Storage test result interface
 * Used for testing storage operations
 */
export interface StorageTestResult {
  success: boolean;
  message: string;
  data?: any;
  error?: {
    statusCode?: number;
    message?: string;
    [key: string]: any;
  };
}

/**
 * File upload result interface
 * Contains information about the result of a file upload operation
 */
export interface FileUploadResult {
  success: boolean;
  path?: string;
  originalName?: string;
  publicUrl?: string;
  message?: string;
  isBucketNotFound?: boolean;
  error?: any;
}

/**
 * File metadata interface
 * Contains metadata about a file stored in Supabase Storage
 */
export interface FileMetadata {
  name: string;
  id?: string;
  size?: number;
  created_at?: string;
  updated_at?: string;
  last_accessed_at?: string;
  metadata?: {
    size?: number;
    mimetype?: string;
    cacheControl?: string;
    lastModified?: string;
    contentLength?: number;
    contentType?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

/**
 * Storage bucket configuration
 * Used to configure storage buckets
 */
export interface BucketConfig {
  name: string;
  public: boolean;
  allowedMimeTypes?: string[];
  maxFileSize?: number;
  description?: string;
  filePrefixes?: string[];
}

/**
 * Available storage buckets
 * Enum of all available storage buckets in the application
 */
export enum StorageBucket {
  TEMPLATES = 'Templates',
  DOCUMENTS = 'documents',
  CALENDARS = 'calendars',
  AVATARS = 'avatars',
  REPORTS = 'reports',
  FORECASTS = 'forecasts'
}

/**
 * File type enum
 * Supported file types for upload
 */
export enum FileType {
  EXCEL = 'excel',
  PDF = 'pdf',
  WORD = 'word',
  IMAGE = 'image',
  TEXT = 'text',
  OTHER = 'other'
}

/**
 * Storage permission level
 * Defines the permission level for storage operations
 */
export enum StoragePermission {
  READ = 'read',
  WRITE = 'write',
  FULL = 'full'
}
